import { OUTSORCED_SUPPLIERS_WITHOUT_OFERTAO } from '../../common/constants'
import { Product } from './types'

const MAX_ALLOWED_QUANTITY_PER_CART = 20000

const getLimitPerOrder = (product: Product) => {
  const { limitPerOrder, supplierPrices, discount } = product

  if (discount) {
    return limitPerOrder == undefined || limitPerOrder == null
      ? MAX_ALLOWED_QUANTITY_PER_CART
      : limitPerOrder
  }

  return !supplierPrices[0].limitPerOrder
    ? MAX_ALLOWED_QUANTITY_PER_CART
    : supplierPrices[0].limitPerOrder
}

export const getProductMaxOrderLimit = (product: Product): number => {
  const [{ getMoreForLess, inStockQuantity, availableQuantity }] = product.supplierPrices
  const is3PSupplier = OUTSORCED_SUPPLIERS_WITHOUT_OFERTAO.includes(
    product.supplierPrices[0].supplierName
  )

  if (getMoreForLess) {
    const limitInUnits = getMoreForLess.limit * product.packageNumberOfItems!
    const stock = inStockQuantity || 0

    if (is3PSupplier) {
      return getMoreForLess.limit
    }

    return Math.min(stock, limitInUnits)
  }
  const availableQuantityValue = availableQuantity ?? MAX_ALLOWED_QUANTITY_PER_CART

  const stock = !is3PSupplier && inStockQuantity ? inStockQuantity : MAX_ALLOWED_QUANTITY_PER_CART

  return Math.min(getLimitPerOrder(product), availableQuantityValue, stock)
}

export const getMaxLimitForMode = (isPackageMode: boolean, product: Product): number => {
  const maxLimit = getProductMaxOrderLimit(product)

  if (isPackageMode) {
    const packageNumberOfItems = product.packageNumberOfItems || 1
    const maxLimitPackage = Math.floor(maxLimit / packageNumberOfItems)

    return maxLimitPackage
  }

  return maxLimit
}

export const getCartQuantityLimitReached = (
  isPackageMode: boolean,
  product: Product,
  quantity: number
): number => {
  const maxLimit = getProductMaxOrderLimit(product)

  if (isPackageMode) {
    const packageNumberOfItems = product.packageNumberOfItems || 1
    const maxLimitPackage = Math.floor(maxLimit / packageNumberOfItems)
    return quantity > maxLimitPackage ? maxLimitPackage : 0
  }

  return quantity > maxLimit ? maxLimit : 0
}
